type Props = {
	theme?: 'light' | 'dark' | 'color'
  }
  
  export function TwitterIcon({ theme = 'color' }: Props) {
	if (theme === 'color') {
	  return (
		<svg
		  xmlns="http://www.w3.org/2000/svg"
		  width="24"
		  height="24"
		  viewBox="0 0 1227 1227"
		>
		  <path
			d="M654.53 592.55 930.65 987.5h-113.32l-225.32-322.28v-.02l-33.08-47.31-263.21-376.5h113.32l212.41 303.85z"
			fill="#fff"
		  />
		  <path
			d="M1094.42 0H132.58C59.36 0 0 59.36 0 132.58v961.84c0 73.22 59.36 132.58 132.58 132.58h961.84c73.22 0 132.58-59.36 132.58-132.58V132.58C1227 59.36 1167.64 0 1094.42 0zm-311.8 1040.52-228.01-331.84-285.47 331.84h-73.78l326.49-379.5-326.49-475.17h249.02l215.91 314.23 270.32-314.23h73.78l-311.33 361.9h-.02l338.6 492.77z"
			fill="#fff"
		  />
		</svg>
	  )
	}
  
	const fillColor = theme === 'dark' ? '#828282' : '#000000'
  
	return (
	  <svg
		width="13"
		height="13"
		viewBox="0 0 13 13"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	  >
		<path
		  className="transition-all"
		  fill={fillColor}
		  fillRule="evenodd"
		  clipRule="evenodd"
		  d="M12.3462 12.9468L7.54782 5.95295L7.55601 5.95951L11.8824 0.946777H10.4367L6.91224 5.02678L4.11342 0.946777H0.321677L4.8014 7.47643L4.80086 7.47587L0.0761719 12.9468H1.52195L5.44028 8.40751L8.55443 12.9468H12.3462ZM3.54057 2.03768L10.273 11.8559H9.12728L2.38943 2.03768H3.54057Z"
		/>
	  </svg>
	)
  }
  